import { ExclusionItemGridBaseDataProvider } from './ExclusionItemGridBaseDataProvider';
export class ExclusionItemGridGzDataProvider extends ExclusionItemGridBaseDataProvider {
  async getDataForView(): Promise<any> {
    return {};
  }
}
